import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatTabGroup } from '@angular/material/tabs';
import { ToastService } from 'angular-toastify';
import { NgxSpinnerService } from 'ngx-spinner';
import { AWS_Envirnoment, AWS_Locations, AWS_NETWORK_SIZE, JIRA_BOARD_PROJECT_Name } from 'src/app/constant/constant';
import { RepositoryService } from 'src/app/service/repository.service';

@Component({
  selector: 'app-awsnewaccountservicerequest',
  templateUrl: './awsnewaccountservicerequest.component.html',
  styleUrls: ['./awsnewaccountservicerequest.component.css']
})
export class AwsnewaccountservicerequestComponent implements OnInit {
  cloudForm: FormGroup;
  appRepoApps: Array<any> = [];
  projectName: string = JIRA_BOARD_PROJECT_Name.AWS;
  summary: string;
  filteredappRepoApps: Array<any> = [];
  @Input() tabGroup!: MatTabGroup

  networkSize: Array<any> = AWS_NETWORK_SIZE;
  locations: Array<any> = AWS_Locations;
  envirnoment: Array<any> = AWS_Envirnoment;
  appRepoAppDetails: any;
  constructor(private fb: FormBuilder, private rs: RepositoryService, private _toastService: ToastService, private spinner: NgxSpinnerService) { }

  ngOnInit(): void {
    this.cloudForm = this.fb.group({
      accountName: ['', [Validators.required]],
      appid: ['', [Validators.required]],
      bu: ['', [Validators.required]],
      rc: ['', [Validators.required]],
      bc: ['', [Validators.required]],
      technicalOwner: ['', [Validators.required]],
      billingOwner: ['', [Validators.required]],
      solutionArchitectureLink: ['', [Validators.required, Validators.pattern('https?://.+')]],
      networkEnable: [null, [Validators.required]],
      networkSize: [''],
      location: ['', [Validators.required]],
      environment: ['', [Validators.required]],
      budget: ['', [Validators.required, Validators.pattern(/^\$?\d+(?:,\d{3})*(?:\.\d+)?$/)]],
    });
    this.getAppsFromAppRepo();
    this.cloudForm.get('appid')!.valueChanges.subscribe(res => {
      this.appSelectAction(res)
    })
  }

  getAppsFromAppRepo() {
    this.spinner.show()
    this.rs.getAppsFromAppRepo("All").subscribe({
      next: (res) => {
        this.appRepoApps = res["Items"].map(res => ({
          ...res,
          result: `${res.appname} ${res.appid}`
        }));
        this.filteredappRepoApps = [... this.appRepoApps];
        this.spinner.hide();
      },
      error: (error) => {
        this._toastService.error(error['message']);
        this.spinner.hide();
      }
    })
  }

  handleFilteredReturn(filteredData: any) {
    this.filteredappRepoApps = filteredData
  }


  appSelectAction(data: string) {
    if (data) {
      this.spinner.show();
      this.rs.getAppsFromAppRepo(data).subscribe({
        next: (res) => {
          this.appRepoAppDetails = res["Items"];
          this.cloudForm.controls.accountName.setValue(this.appRepoAppDetails[0]['appname']);
          this.cloudForm.controls.technicalOwner.setValue(this.appRepoAppDetails[0]['techowner']);
          this.cloudForm.controls.bc.setValue(this.appRepoAppDetails[0]['BC']);
          this.cloudForm.controls.rc.setValue(this.appRepoAppDetails[0]['RC']);
          this.cloudForm.controls.bu.setValue(this.appRepoAppDetails[0]['BU']);
          this.spinner.hide();
        },
        error: (error) => {
          this.spinner.hide();
          this._toastService.error(error?.message)
        }
      })
    }
  }
  resetform(): void {
    this.cloudForm?.reset();
  }

  onSubmit(): void {
    this.spinner.show();
    this.summary = `create New Aws Account for ${this.cloudForm.get('accountName').value}-${this.cloudForm.get('appid').value}`
    this.rs.createCloudServiceRequest(this.projectName, this.summary, this.cloudForm.value, sessionStorage.getItem("wwid")
    ).subscribe({
      next: (res) => {
        this._toastService.success(res['message']);
        this.resetform();
        if (this.tabGroup) { this.tabGroup.selectedIndex = 1 };
        this.spinner.hide();

      },
      error: (error) => {
        this._toastService.error(error?.message || "An unexpected error occurred.");
        this.spinner.hide();

      }
    });
  }
}
